import { CookieRemoveOutlineIcon } from './CookieRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 12200D0C-1B01-4165-A2D1-C5BE30B3E3A7
 * name cookie-remove-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-remove-outline.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitRemoveOutlineIcon = CookieRemoveOutlineIcon;
export default BiscuitRemoveOutlineIcon